<template>
    <q-chip
        v-if="is_visible"
        :color="status_color"
        :icon="status_icon"
        text-color="white">
        {{ status_message }}
    </q-chip>
</template>
  
<script lang="ts" setup>
    /**
     * Setup Variables
     */
    const system = useSystemStore();
    const props = defineProps( {
        onlyWhenOffline: {
            type: Boolean,
            default: false,
            required: false,
        },
    });
    /**
     * Setup Methods
     */
    const is_visible = computed(() => {
        if (props.onlyWhenOffline) {
            return !system.network_status.connected;
        }
        return true;
    });
    const status_icon = computed(() => {
        return system.network_status.connected ? "wifi" : "wifi_off";
    });
    const status_message = computed(() => {
        return system.network_status.connected
        ? `Connected (${system.network_status.connectionType})`
        : "Network Disconnected";
    });
    const status_color = computed(() => {
        return system.network_status.connected ? "green" : "negative";
    });

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const checkConnection = () => {
        system.loadNetworkStatus();
    };
  
  </script>